import React,{useEffect, useState} from 'react'
import "./css/Addpro.css"
import {auth,data} from './firebase';
import { useStateValue } from './StateProvider';
import datae from './json/data.json'
import { useHistory } from 'react-router-dom';
function Addproduct() {
    
    const [{user},dispatch]=useStateValue();
    const [usesa,setUs]=useState([]); 
    const [userdata,setUserData]=useState([]);
    const [catégories,setcatégories]= useState('');
    const [Ville,setVille]= useState('');
    const [titre,settitre]= useState('');
    const [Prix,setPrix]= useState('');
    const [Texte,setTexte]= useState('');
    const [PHOTOS,setPHOTOS]= useState('');
    const history =useHistory();
    useEffect(()=>{
        auth.onAuthStateChanged(authUser=>{
            data.collection("Products").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    setUs(doc.data());
                });
            });
            
            if(authUser){
                
                dispatch({
                    type:'SET_USER',
                    user: authUser
                })
                
            }else{
                dispatch({
                    type:'SET_USER',
                    user: null
                })
            }
        })
        
    },[])
   
   
    const addpro=e=>{
            e.preventDefault();
            const event = new Date();
            const typeword = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' };
            var [day_name,day_number,month,year] = event.toLocaleDateString('fr-FR',typeword).split(" ")
            var time = new Date().toLocaleTimeString("en-US")
            if(catégories!="" && Ville!="" && titre!="" && Prix!="" && Texte!=""){ 
                var rand =(Math.floor(Math.random() * 2753874))*(Math.floor(Math.random() * 2753874))
                var ps= rand.toString()
                data.collection("Products").doc(ps).set({
                    "id":rand,
                    User:(userdata.Prénom),
                    UserNum:(userdata.Téléphone),
                    UID:(user.uid),
                    type:catégories,
                    city:Ville,
                    title:titre,
                    prix:(Prix+" DH"),
                    Texte:Texte,
                    img:PHOTOS,
                    Day: day_name,
                    DayNum: day_number,
                    Month: month,
                    Year: year,
                    Time: time,
                }) 
                history.push("/account?tab=Mes_annonces")
            }else{
                alert("empty")
            }
    }
    if(user){
        data.collection("Users").doc(user.uid).onSnapshot(y=>(
            setUserData(y.data())
        ))
        return (
            <div className="Addproduct">
                <h1>INFORMATIONS GÉNÉRALES</h1>
                <form className=".comp">
                    <div>                
                        <div>
                            <label for="catégories">Type de bien</label><br></br>
                            <select name="catégories" onChange={e=> setcatégories(e.target.value)} id="catégories">
                            <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}} value="INFORMATIQUE ET MULTIMEDIA">-- INFORMATIQUE ET MULTIMEDIA --</option>
                            <option value="Téléphones">Téléphones</option>
                            <option value="Tablettes">Tablettes</option>
                            <option value="Ordinateurs portables">Ordinateurs portables</option>
                            <option value="Ordinateurs de bureau">Ordinateurs de bureau</option>
                            <option value="accessoires informatique et gadgets">Accessoires informatique et Gadgets</option>
                            <option value="Jeux vidéo et Consoles">Jeux vidéo et Consoles</option>
                            <option value="Appareils photo et Caméras">Appareils photo et Caméras</option>
                            <option value="Télévisions">Télévisions</option>
                            <option value="Image &amp; Son">Image &amp; Son</option>
                            <option value="auto_neuf">-- AUTO NEUF --</option>
                            <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}} value="VEHICULES">-- VEHICULES --</option>
                            <option value="Voitures">Voitures</option>
                            <option value="Motos">Motos</option>
                            <option value="Vélos">Vélos</option>
                            <option value="Véhicules Professionnels">Véhicules Professionnels</option>
                            <option value="Bateaux">Bateaux</option>
                            <option value="Pièces et Accessoires pour véhicules">Pièces et Accessoires pour véhicules</option>
                            <option value="new_construction">-- IMMO NEUF --</option>
                            <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}} value="1000">-- IMMOBILIER --</option>
                            <option value="1010">Appartements</option>
                            <option value="1020">Maisons et Villas</option>
                            <option value="1050">Bureaux et Plateaux</option>
                            <option value="1060">Magasins, Commerces et Locaux industriels</option>
                            <option value="1080">Terrains et Fermes</option>
                            <option value="1030">Locations de vacances</option>
                            <option value="1100">Colocations</option>
                            <option value="1090">Autre Immobilier</option>
                            <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}} value="3000">-- POUR LA MAISON ET JARDIN --</option>
                            <option value="3010">Electroménager et Vaisselles</option>
                            <option value="3020">Meubles et Décoration</option>
                            <option value="3040">Jardin et Outils de bricolage</option>
                            <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}} value="8000">-- HABILLEMENT ET BIEN ETRE --</option>
                            <option value="3050">Vêtements</option>
                            <option value="3150">Chaussures</option>
                            <option value="3160">Montres et Bijoux</option>
                            <option value="3060">Sacs et Accessoires</option>
                            <option value="3030">Vêtements pour enfant et bébé</option>
                            <option value="3130">Equipements pour enfant et bébé</option>
                            <option value="3070">Produits de beauté</option>
                            <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}} value="4000">-- LOISIRS ET DIVERTISSEMENT --</option>
                            <option value="4010">Sports et Loisirs</option>
                            <option value="4030">Animaux</option>
                            <option value="4070">Instruments de Musique</option>
                            <option value="4060">Art et Collections</option>
                            <option value="4050">Voyages et Billetterie</option>
                            <option value="4040">Films, Livres, Magazines</option>
                            <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}} value="6000">-- EMPLOI ET SERVICES --</option>
                            <option value="6010">Offres d'emploi</option>
                            <option value="6130">Offres de stages</option>
                            <option value="6050">Centre d'appels</option>
                            <option value="6080">Cadres</option>
                            <option value="6140">Métiers IT</option>
                            <option value="6060">Femmes de Ménages, Nounous et Chauffeurs</option>
                            <option value="6070">Travaux de maison</option>
                            <option value="6020">Demandes d'emploi</option>
                            <option value="6030">Services</option>
                            <option value="6040">Cours et Formations</option>
                            <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}} value="9000">-- ENTREPRISES --</option>
                            <option value="6100">Business et Affaires commerciales</option>
                            <option value="6090">Matériels Professionnels</option>
                            <option value="6120">Stocks et Vente en gros</option>
                            <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}} value="7000">-- Autres --</option>
                            <option value="7010">AUTRES</option>
                        </select> 
                        </div>
                        <div>
                            <label for="Ville">Ville</label><br></br>
                            <select name="Ville" onChange={e=> setVille(e.target.value)} id="Ville">
                            <option value="3" selected="">Tout le Maroc</option>
                            <option value="Casablanca" > Casablanca</option>
                            <option value="Casablanca"> Grand Casablanca</option>
                            <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}}value="0" disabled="disabled">-- AUTRES VILLES --</option>
                            <option id="searcharea_expanded_fisrt_option" value="Ain Harrouda"> Ain Harrouda </option>
                            <option value="Bouskoura"> Bouskoura </option>
                            <option value="Mediouna"> Mediouna </option>
                            <option value="Mohammedia"> Mohammedia </option>
                            <option value="Nouaceur"> Nouaceur </option>
                            <option value="Tamaris"> Tamaris </option>
                            <option value="El Majjatia Ouled Taleb"> El Majjatia Ouled Taleb </option>
                            <option value="Lahraouyine"> Lahraouyine </option>
                            <option value="Sidi Hajjaj Oued Hassar"> Sidi Hajjaj Oued Hassar </option>
                            <option value="Tit Mellil"> Tit Mellil </option>
                            <option value="Dar Bouazza"> Dar Bouazza </option>
                            <option value="Errahma"> Errahma </option>
                            <option value="Lamkansa"> Lamkansa </option>
                            <option value="Oulad Salah"> Oulad Salah </option>
                            <option value="Béni Yakhlef"> Béni Yakhlef </option>
                            <option value="Chellalate"> Chellalate </option>
                            <option value="Sidi Moussa Ben Ali"> Sidi Moussa Ben Ali </option>
                            <option value="Sidi Moussa El Majdoub"> Sidi Moussa El Majdoub </option>
                            <option value="3" style={{color : "red"}}>Choisir une autre ville...</option>
                        </select>
                        </div>
                    </div>          
    
                    <div>
                        <div>
                            <label for="titre">Titre de l'annonce</label>   <br></br>
                            <input type="text" name="titre" onChange={e=> settitre(e.target.value)} id="titre" placeholder="Titre de l'annonce"/> 
                        </div>
                        <div>
                            <label for="Prix">Prix</label>   <br></br>
                            <input type="number" name="Prix" onChange={e=> setPrix(e.target.value)} id="titre" placeholder="0"/> 
                        </div>
                    </div>    
                    <div>
                        <label for="Texte">Texte de l’annonce</label>   <br></br>
                        <textarea name="Texte" id="Texte" onChange={e=> setTexte(e.target.value)} cols="30" rows="10"></textarea>  
                    </div>
                    <div>
                        <label for="PHOTOS">Url PHOTOS</label>   <br></br>
                        <input type="url" name="link" onChange={e=> setPHOTOS(e.target.value)} id="PHOTOS" placeholder="LINK"/> 
                    </div>
                    <input type="submit" onClick={addpro} value="Dépose le"/>
                </form>
            </div>
        )
    }else{
        return(<h1>You need to connect</h1>)
    }
}

export default Addproduct
